import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { getRouteData } from "../shared/services/positions.data.service";
import { setLogout } from "./authActions";

const REQUEST_POSITIONS = "REQUEST_POSITIONS";
const RESPONSE_POSITIONS = "RESPONSE_POSITIONS";
const REQUEST_POSITIONS_FAILURE = "REQUEST_POSITIONS_FAILURE";
const SET_POSITIONS_DATA = "SET_POSITIONS_DATA";
const SET_POSITIONS_PAGE = "SET_POSITIONS_PAGE";
const CLEAR_POSITIONS = "CLEAR_POSITIONS";
const SET_CURRENT_POSITION_DATE = "SET_CURRENT_POSITION_DATE";
const SET_POSITIONS_TABLE_DATA = "SET_POSITIONS_TABLE_DATA";
const SET_POSITIONS_TABLE_SCROLL = "SET_POSITIONS_TABLE_SCROLL";

const requestPositionsAction = () => {
  return {
    type: REQUEST_POSITIONS,
  };
};

const responsePositionsAction = (data) => {
  return {
    type: RESPONSE_POSITIONS,
    payload: data,
  };
};

const requestPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_POSITIONS_FAILURE,
    errors,
  };
};

const getPositions = (options, vehicleReport) => {
  return (dispatch) => {
    dispatch(requestPositionsAction());

    intellegenceService
      .getPositions(
        options.carId,
        {
          startDate: getDates.fixISOStringDateToPost(options.startDate),
          endDate: getDates.fixISOStringDateToPost(options.endDate),
          timeZone: (new Date().getTimezoneOffset() / 60) * -1,
        },
        vehicleReport.id
      )
      .then((result) => {
        dispatch(
          responsePositionsAction(
            getRouteData(result.data, options.carId, vehicleReport)
          )
        );
      })
      .catch((error) => {
        dispatch(requestPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const setPositionsDataAction = (data) => {
  return {
    type: SET_POSITIONS_DATA,
    data,
  };
};

const setPositionsData = (data) => {
  return (dispatch) => {
    dispatch(setPositionsDataAction(data));
  };
};

const setPositionsPageAction = (data) => {
  return {
    type: SET_POSITIONS_PAGE,
    data,
  };
};

const setPositionsPage = (data) => {
  return (dispatch) => {
    dispatch(setPositionsPageAction(data));
  };
};

const clearPositionsAction = () => {
  return {
    type: CLEAR_POSITIONS,
  };
};

const setCurrentPositionDateAction = (data) => {
  return {
    type: SET_CURRENT_POSITION_DATE,
    data,
  };
};

const setCurrentPositionDate = (data) => {
  return (dispatch) => {
    dispatch(setCurrentPositionDateAction(data));
  };
};

const setPositionsTableDataAction = (data) => {
  return {
    type: SET_POSITIONS_TABLE_DATA,
    data,
  };
};

const setPositionsTableData = (data) => {
  return (dispatch) => {
    dispatch(setPositionsTableDataAction(data));
  };
};

const setPositionsTableScrollAction = (data) => {
  return {
    type: SET_POSITIONS_TABLE_SCROLL,
    data,
  };
};

const setPositionsTableScroll = (data) => {
  return (dispatch) => {
    dispatch(setPositionsTableScrollAction(data));
  };
};

export {
  REQUEST_POSITIONS,
  RESPONSE_POSITIONS,
  REQUEST_POSITIONS_FAILURE,
  CLEAR_POSITIONS,
  SET_POSITIONS_DATA,
  SET_POSITIONS_PAGE,
  SET_CURRENT_POSITION_DATE,
  SET_POSITIONS_TABLE_DATA,
  SET_POSITIONS_TABLE_SCROLL,
  requestPositionsAction,
  responsePositionsAction,
  requestPositionsFailureAction,
  getPositions,
  setPositionsDataAction,
  setPositionsData,
  setPositionsPageAction,
  setPositionsPage,
  clearPositionsAction,
  setCurrentPositionDateAction,
  setCurrentPositionDate,
  setPositionsTableDataAction,
  setPositionsTableData,
  setPositionsTableScrollAction,
  setPositionsTableScroll,
};
